/** API 분 단위 → 표시용 시간(시). 서버 스펙 변경 없이 프론트만 변환. */
export function minutesToHoursNumber(minutes: unknown): number | null {
  if (minutes === null || minutes === undefined || minutes === "") return null;
  const m = typeof minutes === "number" ? minutes : Number(minutes);
  if (Number.isNaN(m)) return null;
  return m / 60;
}

/** 소수 첫째 자리까지 (예: 198.0, 2.5). null/NaN이면 empty 문자열 반환 */
export function formatHoursFromMinutes(minutes: unknown, empty = "-"): string {
  const h = minutesToHoursNumber(minutes);
  if (h === null) return empty;
  return h.toFixed(1);
}
